import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'webform-illustration-section',
  templateUrl: './illustration-section.component.html',
})
export class WebformIllustrationSectionComponent {
  @Input() element: Record<string, unknown> = {};

  get illustration(): string {
    return this.getString('#illustration');
  }

  get title(): string {
    return this.getString('#title');
  }

  get text(): string {
    return this.getString('#text');
  }

  private getString(key: string): string {
    const value = this.element[key];
    return typeof value === 'string' ? value : '';
  }
}
